/**
 * @module alpha-util/log
 * @type {{info: info, deprecated: deprecated}}
 */
module.exports = {
    /**
     * 输出一段调试文本
     */
    info : function(message) {
        if(window.console) {
            window.console.log(message);
        }
    },
    /**
     * 弃用某个方法
     * @param method  {String} 要弃用的方法
     * @param instead {String} 要替代的方法
     * @param version {String} 从哪个版本开始弃用
     * @example
     *  var log = require('@alife/alpha-util/log');
     *  log.deprecated('_setPosition', 'setPosition', '1.0.5');
     */
    deprecated : function(method, instead, version) {
        if(window.console) {
            window.console.log(method + ' is deprecated at [ '+ version +' ], use [ ' + instead + ' ] instead of it.');
        }
    }
}